// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  padding: 20px;
  background: rgba(255, 255, 255, 0.9);
  padding: 0.5vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-radius: 0.3vw;
}

.product-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
  font-family: Arial, sans-serif;
}
.product-table tr,
.product-table td,
.product-table th {
  padding: 1vw 2vw;
}
.product-table th p,
.product-table td p {
  font-weight: 400;
  font-size: 0.91vw;
  color: #3a3a3a;
}
.product-table thead tr {
  background-color: #f9f9f9;
}
.product-table thead tr:first-child th:last-child {
  border-bottom: 0.1vw solid #ececec;
}
.product-table thead p {
  text-align: center;
}
.product-table tbody tr {
  border-bottom: 1px solid #e4e4e4;
}
.product-table tbody tr .product-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 1vw;
}
.product-table tbody tr .product-container img {
  width: 3vw;
  height: 3vw;
  object-fit: cover;
}
.product-table th[rowspan="2"] {
  vertical-align: bottom;
}
.product-table th[colspan="3"] {
  text-align: center;
}
.product-table th[colspan="3"] p {
  font-weight: 500;
}

.pagination {
  display: flex;
  justify-content: space-around;
  width: 40%;
  margin: 1.8vw auto 0;
}
.pagination button {
  background-color: transparent;
  border: none;
  padding: 8px 12px;
  margin: 0 2px;
  cursor: pointer;
  font-weight: 400;
  font-size: 0.91vw;
  color: #ababab;
}
.pagination button.active {
  color: #2e3896;
}
.pagination button:disabled {
  cursor: not-allowed;
}
.pagination button:disabled svg path {
  fill: #ababab !important;
}
.pagination button:first-child svg, .pagination button:last-child svg {
  width: 25px;
  height: 25px;
  overflow: hidden;
  border-radius: 50%;
  border: 0.1vw solid #ababab;
}`, "",{"version":3,"sources":["webpack://./src/style/components/analytics/ProductAnalytic.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,cAAA;EACA,+DAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,gBAAA;EACA,8BAAA;AACF;AACE;;;EAGE,gBAAA;AACJ;AACE;;EAEE,gBAAA;EACA,iBAAA;EACA,cAAA;AACJ;AAGI;EACI,yBAAA;AADR;AAKY;EACE,kCAAA;AAHd;AAQM;EACE,kBAAA;AANR;AASE;EACE,gCAAA;AAPJ;AAQI;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,QAAA;AANR;AAOQ;EACI,UAAA;EACA,WAAA;EACA,iBAAA;AALZ;AAUE;EACE,sBAAA;AARJ;AAWE;EACE,kBAAA;AATJ;AAUI;EACE,gBAAA;AARN;;AAaA;EACE,aAAA;EACA,6BAAA;EAmCA,UAAA;EACA,oBAAA;AA5CF;AASE;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;AAPJ;AASI;EACE,cAAA;AAPN;AAUI;EACE,mBAAA;AARN;AAUQ;EACI,wBAAA;AARZ;AAeM;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;AAbR","sourcesContent":[".table-container {\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 0.5vw;\n  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n  border-radius: 0.3vw;\n}\n\n.product-table {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n  font-family: Arial, sans-serif;\n\n  tr,\n  td,\n  th {\n    padding: 1vw 2vw;\n  }\n  th p,\n  td p {\n    font-weight: 400;\n    font-size: 0.91vw;\n    color: #3a3a3a;\n  }\n\n  thead {\n    tr {\n        background-color: #f9f9f9;\n    \n        &:first-child {\n          th {\n            &:last-child {\n              border-bottom: 0.1vw solid #ececec;\n            }\n          }\n        }\n      }\n      p{\n        text-align: center;\n      }\n  }\n  tbody tr {\n    border-bottom: 1px solid #e4e4e4;\n    .product-container{\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 1vw;\n        img{\n            width: 3vw;\n            height: 3vw;\n            object-fit: cover;\n        }\n    }\n  }\n\n  th[rowspan=\"2\"] {\n    vertical-align: bottom;\n  }\n\n  th[colspan=\"3\"] {\n    text-align: center;\n    p {\n      font-weight: 500;\n    }\n  }\n}\n\n.pagination {\n  display: flex;\n  justify-content: space-around;\n  button {\n    background-color: transparent;\n    border: none;\n    padding: 8px 12px;\n    margin: 0 2px;\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 0.91vw;\n    color: #ababab;\n\n    &.active {\n      color: #2e3896;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      svg{\n        path{\n            fill:#ababab !important;\n        }\n      }\n    }\n\n    &:first-child,\n    &:last-child {\n      svg{\n        width: 25px;\n        height: 25px;\n        overflow: hidden;\n        border-radius: 50%;\n        border: 0.1vw solid #ababab;\n      }\n    }\n  }\n  width: 40%;\n  margin: 1.8vw auto 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
